<template>
  <div class="ml-3" style="width: 72px; min-width: 72px; z-index: 9">
    <v-select
      :items="items"
      v-model="selectLang"
      solo
      dense
      hide-details
      item-text="name"
      item-value="val"
      @change="handleChangeLanguage"
      style="border-radius: 24px"
      :menu-props="{ contentClass: 'custom-dropdown-menu-language' }"
    >
      <template v-slot:selection="{ item }">
        <v-img :src="item.image" max-height="20" max-width="20"
      /></template>
      <template v-slot:item="{ item }">
        <v-col class="text-center">
          <v-img
            :src="item.image"
            max-height="20"
            max-width="20"
            class="text-center"
          />
        </v-col>
      </template>
    </v-select>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "SelectLangauge",
  data() {
    return {
      selectLang: null,
      items: [
        {
          val: "th",
          name: "Thai",
          image: "https://flagcdn.com/th.svg",
        },
        {
          val: "en",
          name: "English",
          image: "https://flagcdn.com/gb.svg",
        },
        // {
        //   val: "id",
        //   name: "Indonesian",
        //   image: "https://flagcdn.com/id.svg",
        // },
        // {
        //   val: "ja",
        //   name: "Japanese",
        //   image: "https://flagcdn.com/jp.svg",
        // },
        // {
        //   val: "cn",
        //   name: "Chinese",
        //   image: "https://flagcdn.com/cn.svg",
        // },
        // {
        //   val: "kr",
        //   name: "Korean",
        //   image: "https://flagcdn.com/kr.svg",
        // },
      ],
    };
  },
  mounted() {
    const lang = this.$store.state.defaultSystem.language;
    const modelLang = this.items.find((x) => x.val == lang);
    if (modelLang) {
      this.$i18n.locale = modelLang.val;
      this.$vuetify.lang.current = modelLang.val;
      this.$store.commit("defaultSystem/SET_LANGUAGE", modelLang.val);
      this.selectLang = modelLang;
    }
  },
  methods: {
    handleChangeLanguage() {
      window.location.reload();
    },
  },
  computed: {
    ...mapState("defaultSystem", ["customer"]),
  },
  watch: {
    selectLang(val) {
      let value = val?.val || val;
      this.$i18n.locale = value;
      this.$vuetify.lang.current = value;
      this.$store.commit("defaultSystem/SET_LANGUAGE", value);
      this.selectLang = val;
    },
  },
};
</script>

<style>
.custom-dropdown-menu-language {
  border-radius: 20px !important;
}
</style>

<style lang="scss" scoped>
</style>
